import React, {useCallback, useEffect, useRef, useState} from 'react';
import FileUpload from '../../resources/icon/file-upload.png'
import UploadHere from '../../resources/icon/upload.png'
import Forbidden from '../../resources/icon/forbidden.png'
import EXCEL from '../../resources/icon/excel-icon.png'
import PPTX from '../../resources/icon/ppt-icon.png'
import PDF from '../../resources/icon/pdf-icon.png'
import Word from '../../resources/icon/word-icon.png'
import Doc from '../../resources/icon/documnet-icon.png'
import HWP from '../../resources/icon/hwp-icon.png'
import IMG from '../../resources/icon/img-upload.png'
import ZIP from '../../resources/icon/zip-icon.png'
import MAIL from '../../resources/icon/mail-dark.png'


/**
 * `파일업로더 `파일
 * */

function FileUploader({className, filed, required, message}) {
    const [error, setError] = useState("");

    useEffect(() => {
        if (required && filed.files.length === 0) {
            setError(message??"파일을 최소 1개 이상 첨부해주세요.");
        } else {
            setError("");
        }
    }, [filed.files, required]);

    const imageMap = {
        'PDF': PDF,
        'PPTX': PPTX,
        'POWERPOINT': PPTX,
        'WORD':Word ,
        'DOCX' : Word,
        'XLS' : EXCEL,
        'XLSX' : EXCEL,
        'HWP' : HWP,
        'JPG' : IMG,
        'JPNG' : IMG,
        'JPEG' : IMG,
        'PNG' : IMG,
        'ZIP' : ZIP,
        'MSG' : MAIL,
        'EML' : MAIL,
    };

    const acceptedFileTypes = [
        'application/vnd.hancom.hwp',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/pdf',
        'image/tiff',
        'text/plain',
        'image/jpeg', // JPG, JPEG
        'image/png',  // PNG
        'application/x-hwp', // HWP 파일
        'application/haansofthwp', // HWP 파일
        'application/haansoft-hwp', // HWP 파일
        'application/octet-stream', // HWP 파일
        'application/zip', // ZIP 파일
        'application/x-zip-compressed', // ZIP 파일
        'multipart/x-zip', // ZIP 파일
        'application/octet-stream', // ZIP 파일
        'application/vnd.ms-outlook', // .msg
        'application/octet-stream',   // fallback for .msg/.eml
        'message/rfc822',             // .eml
    ];

    function fileTypeChecker(file, extension) {
        return acceptedFileTypes.includes(file.type) || (file.type == "" && ['hwp', 'msg', 'eml'].includes(extension.toLowerCase()))
    }

    // 드래그 중일때와 아닐때의 스타일을 구분하기 위한 state 변수
    const [isDragging, setIsDragging] = useState(false);
    const [dragIn, setDragIn]=useState(false);
    // 각 선택했던 파일들의 고유값 id
    const fileId = useRef(0);
    // 드래그 이벤트를 감지하는 ref 참조변수 (label 태그에 들어갈 예정)
    const dragRef = useRef(null);

    const onChangeFiles = useCallback((e) => {
        let selectFiles = [];
        if (e.type === "drop") {
            // 드래그 앤 드롭 했을 때
            selectFiles = Array.from(e.dataTransfer.files);
        } else {
            // "파일 첨부" 버튼을 눌러서 이미지를 선택했을 때
            selectFiles = Array.from(e.target.files);
        }

        const prevFiles = [...filed.files];
        const newFiles = [];

        let loaded = 0;

        if (selectFiles.length === 0) return;

        selectFiles.forEach((file, idx) => {
            console.log(selectFiles)
            const id = fileId.current++;
            const extension = file.name.substring(file.name.lastIndexOf('.') + 1);

            if (fileTypeChecker(file, extension)) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const previewImage = event.target.result;
                    newFiles[idx] = {
                        id,
                        object: file,
                        previewImage,
                    };

                    loaded++;
                    // 모든 파일 로드가 끝나면 한 번에 setState 하기
                    if (loaded === selectFiles.length) {
                        filed.setFiles([...prevFiles, ...newFiles]);
                    }
                };
                reader.readAsDataURL(file);
            } else {
                alert('지원하지 않는 파일 형식입니다.\n형식 : '+file.type);
            }
        }

    )}, [filed.files, filed.setFiles]);

    const handleDeleteImage = (id) => {
        // 파일 목록에서도 해당 이미지를 제거
        const newFiles = filed.files.filter((file) => file.id !== id);
        filed.setFiles(newFiles);
    };

    const handleFileInputChange = (e) => {
        // 드래그 앤 드롭이 아닌 경우에만 파일 목록 처리
        if (!isDragging) {
            onChangeFiles(e);
            e.target.value = null; // 추가: 같은 파일 재업로드 허용
        }
    };

    const handleDragIn = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        setDragIn(true);
    }, []);

    const handleDragOut = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        setDragIn(false);
    }, []);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files.length > 0) {
            setIsDragging(true);
        } else {
            setIsDragging(false);
        }
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files.length > 0) {
            setIsDragging(false);
            setDragIn(false);
            onChangeFiles(e);
        }
    }, [onChangeFiles]);

    const initDragEvents = useCallback(() => {
        if (dragRef.current !== null) {
            dragRef.current.addEventListener("dragenter", handleDragIn);
            dragRef.current.addEventListener("dragleave", handleDragOut);
            dragRef.current.addEventListener("dragover", handleDragOver);
            dragRef.current.addEventListener("drop", handleDrop);
        }
    }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

    const resetDragEvents = useCallback(() => {
        // 앞서 말했던 4개의 이벤트에 Listener를 삭제합니다. (언마운트 될때)
        if (dragRef.current !== null) {
            dragRef.current.removeEventListener("dragenter", handleDragIn);
            dragRef.current.removeEventListener("dragleave", handleDragOut);
            dragRef.current.removeEventListener("dragover", handleDragOver);
            dragRef.current.removeEventListener("drop", handleDrop);
        }
    }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

    useEffect(() => {
        initDragEvents();

        return () => resetDragEvents();
    }, [initDragEvents, resetDragEvents]);

    return (
        <div className={`w-full relative z-index-1 ${className ?? ""}`}>
            <div
                ref={dragRef}
                className={`b-gray upload-h ${isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}`}
            >
                {error && <div style={{ color: "red" }}>{error}</div>}

                {dragIn ?
                    (<>     {/* 드래그 하는 중 */}
                        <img src={UploadHere} className="w-[50px] inline-block mt-4 mb-4 drag-drop-img "/>
                        <span className=" c-gray drag-drop-txt">여기에 놓으세요</span>
                    </>)
                    :
                    (<>     {/* 드래그 하지 않는 중 */}
                        {filed.files.map((file) => {
                            const fileName = file.object.name;
                            const ext = (fileName.slice(fileName.lastIndexOf('.') + 1)).toUpperCase();
                            return (
                                <div className="uploaded-img  mt-[10px]" key={file.id}>
                                    <div className="delete-image" onClick={() => handleDeleteImage(file.id)}>
                                        <img src={Forbidden} />
                                    </div>

                                    <>
                                        <img src={imageMap[ext] ? imageMap[ext] : Doc } className="w-[50px] uploaded-file" />
                                        <span className="text-nowrap">{fileName.length > 11 ? fileName.substring(0,7)+"..." : fileName}</span>
                                    </>
                                </div>)
                        })}

                        <img src={FileUpload} className="w-[50px] inline-block mt-4 mb-4 drag-drop-img"/>
                        <span className="c-gray drag-drop-txt">파일을 끌어서 놓으세요</span>
                    </>)}

            </div>
            <div className="py-3 bg-basic h-[40px]">
                <label  className="file-from-my px-6 py-1 b-gray bg-white item-center"
                        htmlFor={"file_doc"}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 inline-block mr-2" >
                        <path
                            d="M9.25 13.25a.75.75 0 0 0 1.5 0V4.636l2.955 3.129a.75.75 0 0 0 1.09-1.03l-4.25-4.5a.75.75 0 0 0-1.09 0l-4.25 4.5a.75.75 0 1 0 1.09 1.03L9.25 4.636v8.614Z"/>
                        <path
                            d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z"/>
                    </svg>
                    <span className={'line-h-22'}>내 PC에서 파일 찾기</span>
                </label>
                <input
                    className="hidden"
                    id={"file_doc"}
                    type={"file"}
                    multiple={true}
                    onChange={handleFileInputChange}
                />

            </div>
        </div>
    );
}

export default FileUploader;
